export const twitterReviews = [
  {
    name: 'Simon Grimm',
    twitter: 'schlimmson',
    imageSrc: '/images/twitter/schlimmson.png',
    text: 'Tried @grafbase and was impressed how easy & fast it was to create your serverless GraphQL API + local instance 🔥',
    link: 'https://twitter.com/schlimmson/status/1617960253018046483',
    date: '12:59 PM · Jan 24, 2023'
  },
  {
    name: 'Rasmus Hjulskov',
    twitter: 'RasmusHjulskov',
    imageSrc: '/images/twitter/rasmushjulskov.png',
    text:
      'Current fantasy tech stack 🚀: \n' +
      '- @nextjs \n' +
      '- @tailwindcss \n' +
      '- @typescript \n' +
      '- @trpcio \n' +
      '- @grafbase \n' +
      '- @ClerkDev \n',
    link: 'https://twitter.com/RasmusHjulskov/status/1613628578276737024',
    date: '2:06 PM · Jan 12, 2023'
  },
  {
    name: 'Kate',
    twitter: 'whoiskatrin',
    imageSrc: '/images/twitter/whoiskatrin.png',
    text: "As an engineer, I'm always on the lookout for tools that make my job easier and more efficient. @grafbase has quickly become a go-to for me in my #GraphQL development work. Its real-time query execution and intuitive schema management have saved me countless hours of debugging",
    link: 'https://twitter.com/whoiskatrin/status/1607855165867950083',
    date: '3:45 PM · Dec 27, 2022'
  },
  {
    name: 'Roy',
    twitter: 'royboy789',
    imageSrc: '/images/twitter/royboy789.png',
    text:
      'Done playing with @Cloudflare Pages & Workers, for now. \n\n' +
      'Now to learn some @grafbase and see how if it can play a role, because it is pretty nifty!',
    link: 'https://twitter.com/royboy789/status/1599812033737678851',
    date: '11:04 AM · Dec 5, 2022'
  },
  {
    name: 'Bobby Blastbeats',
    twitter: 'tubbo',
    imageSrc: '/images/twitter/tubbo.png',
    text:
      "not sure if @grafbase is so good that it will actually obviate my entire job, or if it's good enough that i can use it at work without someone questioning my existence.\n\n" +
      'either way, i am sold on the concept of "upload some SDL and query shit, stop worrying about the DB infra".',
    link: 'https://twitter.com/tubbo/status/1589676318425509890',
    date: '05:32 PM · Nov 7, 2022'
  },
  {
    name: 'Ben',
    twitter: 'nurodev',
    imageSrc: '/images/twitter/nurodev.png',
    text: "Damn, trying out the @grafbase beta & it's super slick!\n\nFeels like what @planetscaledata is doing for databases, @Grafbase is going for #GraphQL 🔥",
    link: 'https://twitter.com/nurodev/status/1545392507147673602',
    date: '4:01 PM · Jul 8, 2022'
  }
]
